import React from "react";
import classes from "./BrandingContent.module.scss";

const BrandingContent: React.FC = () => (
  <div style={{ height: "730px" }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      width="100%"
      height="950"
      viewBox="0 0 450 1155"
    >
      <rect className={classes.cls1} x="-7" y="-6" width="464" height="1169" />
      <rect className={classes.cls2} x="54" width="170" height="58" />
      <path
        className={classes.cls3}
        d="M57.61,149.11a17.51,17.51,0,0,0,12.72,5.4c4.67,0,7-2.22,7-4.5,0-3-3.48-4-8.1-5.1-6.53-1.5-14.93-3.3-14.93-12.24,0-6.66,5.75-12.06,15.17-12.06,6.36,0,11.64,1.92,15.6,5.58l-4.74,6.24a17.07,17.07,0,0,0-11.45-4.38c-3.84,0-5.88,1.68-5.88,4.08,0,2.7,3.35,3.54,8,4.62,6.6,1.5,15,3.48,15,12.36,0,7.32-5.22,12.84-16,12.84-7.68,0-13.2-2.58-17-6.36Z"
      />
      <path
        className={classes.cls3}
        d="M104.64,131.53c8.64,0,14.52,6.48,14.52,16v1.68H97.62c.48,3.66,3.42,6.72,8.34,6.72A11.85,11.85,0,0,0,113.7,153l3.36,4.92c-2.94,2.7-7.44,4-11.94,4-8.82,0-15.48-5.94-15.48-15.24C89.64,138.31,95.82,131.53,104.64,131.53ZM97.5,144h14.28a6.71,6.71,0,0,0-7.14-6.42A7,7,0,0,0,97.5,144Z"
      />
      <path
        className={classes.cls3}
        d="M138.18,131.53c5.94,0,9.54,2.58,11.46,5.28l-5,4.62a7.17,7.17,0,0,0-6.12-3.12c-4.62,0-7.86,3.36-7.86,8.4s3.24,8.46,7.86,8.46a7.31,7.31,0,0,0,6.12-3.12l5,4.62c-1.92,2.7-5.52,5.28-11.46,5.28-8.94,0-15.36-6.3-15.36-15.24S129.24,131.53,138.18,131.53Z"
      />
      <path
        className={classes.cls3}
        d="M174.18,161.23v-3.66A13.56,13.56,0,0,1,164,162c-6.36,0-9.36-3.48-9.36-9.12V132.25h7.62v17.58c0,4,2.1,5.34,5.34,5.34a8.53,8.53,0,0,0,6.6-3.3V132.25h7.62v29Z"
      />
      <path
        className={classes.cls3}
        d="M189.36,161.23v-29H197v4a12.4,12.4,0,0,1,9.24-4.62V139a10.12,10.12,0,0,0-2.1-.18c-2.52,0-5.88,1.38-7.14,3.24v19.14Z"
      />
      <path
        className={classes.cls3}
        d="M224.1,131.53c8.64,0,14.52,6.48,14.52,16v1.68H217.08c.48,3.66,3.42,6.72,8.34,6.72a11.85,11.85,0,0,0,7.74-2.88l3.36,4.92c-2.94,2.7-7.44,4-11.94,4-8.82,0-15.48-5.94-15.48-15.24C209.1,138.31,215.28,131.53,224.1,131.53ZM217,144h14.28a6.71,6.71,0,0,0-7.14-6.42A7,7,0,0,0,217,144Z"
      />
      <path
        className={classes.cls3}
        d="M259.68,161.23v-40H288v7.32H268.2v8.7h19.38v7.32H268.2v16.68Z"
      />
      <path
        className={classes.cls3}
        d="M293,123.43a4.56,4.56,0,1,1,4.56,4.56A4.6,4.6,0,0,1,293,123.43Zm.78,37.8v-29h7.62v29Z"
      />
      <path className={classes.cls3} d="M308.94,161.23v-40h7.62v40Z" />
      <path
        className={classes.cls3}
        d="M337.26,131.53c8.64,0,14.52,6.48,14.52,16v1.68H330.24c.48,3.66,3.42,6.72,8.34,6.72a11.85,11.85,0,0,0,7.74-2.88l3.36,4.92c-2.94,2.7-7.44,4-11.94,4-8.82,0-15.48-5.94-15.48-15.24C322.26,138.31,328.44,131.53,337.26,131.53ZM330.12,144H344.4a6.71,6.71,0,0,0-7.14-6.42A7,7,0,0,0,330.12,144Z"
      />
      <path
        className={classes.cls3}
        d="M57.61,209.24a17.51,17.51,0,0,0,12.72,5.4c4.67,0,7-2.22,7-4.5,0-3-3.48-4-8.1-5.1-6.53-1.5-14.93-3.3-14.93-12.24,0-6.66,5.75-12.06,15.17-12.06,6.36,0,11.64,1.92,15.6,5.58l-4.74,6.24a17.07,17.07,0,0,0-11.45-4.38c-3.84,0-5.88,1.68-5.88,4.08,0,2.7,3.35,3.54,8,4.62,6.6,1.5,15,3.48,15,12.36,0,7.32-5.22,12.84-16,12.84-7.68,0-13.2-2.58-17-6.36Z"
      />
      <path
        className={classes.cls3}
        d="M111.12,221.36V203.72c0-4-2.1-5.28-5.4-5.28a8.44,8.44,0,0,0-6.6,3.42v19.5H91.5v-40h7.62v14.82a13.41,13.41,0,0,1,10.2-4.5c6.36,0,9.42,3.48,9.42,9.12v20.58Z"
      />
      <path
        className={classes.cls3}
        d="M143.7,221.36v-3c-2,2.34-5.4,3.72-9.18,3.72-4.62,0-10.08-3.12-10.08-9.6,0-6.78,5.46-9.24,10.08-9.24,3.84,0,7.26,1.2,9.18,3.54v-4c0-2.94-2.52-4.86-6.36-4.86a12.19,12.19,0,0,0-8.46,3.42l-2.88-5.1a19,19,0,0,1,12.66-4.56c6.6,0,12.66,2.64,12.66,11v18.72Zm0-10.56c-1.26-1.68-3.66-2.52-6.12-2.52-3,0-5.46,1.62-5.46,4.38s2.46,4.26,5.46,4.26c2.46,0,4.86-.84,6.12-2.52Z"
      />
      <path
        className={classes.cls3}
        d="M158.88,221.36v-29h7.62v4a12.4,12.4,0,0,1,9.24-4.62v7.44a10.12,10.12,0,0,0-2.1-.18c-2.52,0-5.88,1.38-7.14,3.24v19.14Z"
      />
      <path
        className={classes.cls3}
        d="M179.7,183.56a4.56,4.56,0,1,1,4.56,4.56A4.6,4.6,0,0,1,179.7,183.56Zm.78,37.8v-29h7.62v29Z"
      />
      <path
        className={classes.cls3}
        d="M215.22,221.36V203.84c0-4-2.1-5.4-5.34-5.4a8.25,8.25,0,0,0-6.6,3.42v19.5h-7.62v-29h7.62v3.78a13.27,13.27,0,0,1,10.14-4.5c6.36,0,9.42,3.6,9.42,9.24v20.46Z"
      />
      <path
        className={classes.cls3}
        d="M233.22,223.28c2.34,2.58,5.4,3.6,9.06,3.6s8-1.62,8-7.32v-2.94a11.29,11.29,0,0,1-8.94,4.56c-7.26,0-12.78-5.1-12.78-14.76,0-9.48,5.46-14.76,12.78-14.76a11.16,11.16,0,0,1,8.94,4.44v-3.72h7.68v27c0,11-8.52,13.74-15.66,13.74-5,0-8.88-1.14-12.48-4.32Zm17-21.54a8.26,8.26,0,0,0-6.54-3.3c-4.32,0-7.32,3-7.32,8s3,8,7.32,8a8.44,8.44,0,0,0,6.54-3.3Z"
      />
      <path className={classes.cls4} d="M77.28,36.68V20.32h3.49V36.68Z" />
      <path
        className={classes.cls4}
        d="M88.76,36.68V23.39H84V20.32H97v3.07H92.26V36.68Z"
      />
      <path
        className={classes.cls4}
        d="M100,26a4.13,4.13,0,0,0,1.88-2.33,1.06,1.06,0,0,1-.46.09A1.68,1.68,0,0,1,99.76,22a2,2,0,0,1,1.91-2,2.27,2.27,0,0,1,2.21,2.5,5.71,5.71,0,0,1-2.53,4.56Z"
      />
      <path
        className={classes.cls4}
        d="M108.24,31.72a7.17,7.17,0,0,0,5.2,2.21c1.91,0,2.85-.91,2.85-1.84,0-1.22-1.43-1.64-3.31-2.08-2.68-.61-6.11-1.35-6.11-5,0-2.73,2.35-4.93,6.2-4.93a9.09,9.09,0,0,1,6.38,2.28l-1.94,2.55a7,7,0,0,0-4.68-1.79c-1.57,0-2.41.68-2.41,1.67s1.38,1.44,3.27,1.88c2.69.62,6.13,1.43,6.13,5,0,3-2.14,5.25-6.55,5.25a9.41,9.41,0,0,1-6.94-2.6Z"
      />
      <path
        className={classes.cls4}
        d="M141.61,36.68V29.81h-7.73v6.87H130.4V20.32h3.48v6.43h7.73V20.32h3.51V36.68Z"
      />
      <path
        className={classes.cls4}
        d="M149.3,36.68V20.32h11.58v3h-8.1v3.56h7.92v3h-7.92v3.8h8.1v3Z"
      />
      <path
        className={classes.cls4}
        d="M173.82,36.68l-3.21-5.86h-2.55v5.86h-3.49V20.32h7.65c3.41,0,5.5,2.23,5.5,5.27a4.7,4.7,0,0,1-3.58,4.86l3.67,6.23Zm-2.11-13.37h-3.65v4.52h3.65a2.27,2.27,0,1,0,0-4.52Z"
      />
      <path
        className={classes.cls4}
        d="M181.32,36.68V20.32h11.57v3H184.8v3.56h7.92v3H184.8v3.8h8.09v3Z"
      />
      <path
        className={classes.cls4}
        d="M198.11,33a2,2,0,1,1-2,2A2,2,0,0,1,198.11,33Zm-1.38-1.62-.54-11H200l-.49,11Z"
      />
      <path
        className={classes.cls3}
        d="M52.82,273.42A8.19,8.19,0,0,1,61.21,265a7.42,7.42,0,0,1,6.5,3.46l-2.09,1.1a5.18,5.18,0,0,0-4.41-2.38c-3.31,0-5.86,2.6-5.86,6.28s2.55,6.28,5.86,6.28a5.18,5.18,0,0,0,4.41-2.38l2.09,1.1a7.42,7.42,0,0,1-6.5,3.46A8.19,8.19,0,0,1,52.82,273.42Z"
      />
      <path
        className={classes.cls3}
        d="M69.37,275.65a6,6,0,1,1,12,0c0,3.44-2.28,6.23-6,6.23S69.37,279.09,69.37,275.65Zm9.66,0c0-2.23-1.3-4.24-3.68-4.24s-3.68,2-3.68,4.24,1.33,4.27,3.68,4.27S79,277.91,79,275.65Z"
      />
      <path
        className={classes.cls3}
        d="M98.52,281.59v-7.9c0-1.37-.61-2.28-2.06-2.28a3.8,3.8,0,0,0-2.94,1.69v8.49H91.31v-7.9c0-1.37-.59-2.28-2.08-2.28a3.87,3.87,0,0,0-2.9,1.72v8.46h-2.2V269.74h2.2v1.67a5.15,5.15,0,0,1,3.83-2,3.06,3.06,0,0,1,3.21,2.21,5,5,0,0,1,4-2.21c2.18,0,3.36,1.2,3.36,3.58v8.56Z"
      />
      <path
        className={classes.cls3}
        d="M104.23,281.59V265.23h2.2v6.23a4.76,4.76,0,0,1,3.88-2c3.09,0,5.27,2.43,5.27,6.23s-2.21,6.2-5.27,6.2a4.89,4.89,0,0,1-3.88-2v1.69Zm2.2-3.39a4,4,0,0,0,3.29,1.72c2.21,0,3.58-1.77,3.58-4.24s-1.37-4.27-3.58-4.27a4.08,4.08,0,0,0-3.29,1.77Z"
      />
      <path
        className={classes.cls3}
        d="M118.05,266.36a1.43,1.43,0,0,1,2.85,0,1.43,1.43,0,0,1-2.85,0Zm.35,15.23V269.74h2.2v11.85Z"
      />
      <path
        className={classes.cls3}
        d="M132.1,281.59V274c0-2-1-2.6-2.53-2.6a4.22,4.22,0,0,0-3.26,1.72v8.46h-2.2V269.74h2.2v1.67a5.66,5.66,0,0,1,4.2-2c2.5,0,3.8,1.32,3.8,3.82v8.32Z"
      />
      <path
        className={classes.cls3}
        d="M137.47,266.36a1.42,1.42,0,1,1,2.84,0,1.42,1.42,0,0,1-2.84,0Zm.34,15.23V269.74H140v11.85Z"
      />
      <path
        className={classes.cls3}
        d="M151.51,281.59V274c0-2-1-2.6-2.52-2.6a4.22,4.22,0,0,0-3.26,1.72v8.46h-2.21V269.74h2.21v1.67a5.62,5.62,0,0,1,4.19-2c2.5,0,3.8,1.32,3.8,3.82v8.32Z"
      />
      <path
        className={classes.cls3}
        d="M158.18,283a4.61,4.61,0,0,0,3.8,1.57c1.84,0,3.68-.88,3.68-3.39v-1.54a5,5,0,0,1-3.9,2c-3.07,0-5.27-2.26-5.27-6.14s2.2-6.1,5.27-6.1a4.83,4.83,0,0,1,3.9,2v-1.72h2.21v11.38c0,4.07-3,5.27-5.89,5.27a6.37,6.37,0,0,1-4.86-1.76Zm7.48-9.86a4.14,4.14,0,0,0-3.29-1.74c-2.2,0-3.58,1.72-3.58,4.14s1.38,4.17,3.58,4.17a4.16,4.16,0,0,0,3.29-1.76Z"
      />
      <path
        className={classes.cls3}
        d="M178.13,279v-7.28h-2v-1.94h2v-3.23h2.21v3.23h2.4v1.94h-2.4v6.79c0,.84.39,1.45,1.15,1.45a1.66,1.66,0,0,0,1.2-.47l.57,1.67a3.16,3.16,0,0,1-2.31.76C179.09,281.88,178.13,280.83,178.13,279Z"
      />
      <path
        className={classes.cls3}
        d="M193.19,281.59V274c0-2-1-2.55-2.53-2.55a4.22,4.22,0,0,0-3.26,1.72v8.46h-2.21V265.23h2.21v6.18a5.67,5.67,0,0,1,4.19-2c2.53,0,3.8,1.27,3.8,3.78v8.36Z"
      />
      <path
        className={classes.cls3}
        d="M204.12,269.45c3.55,0,5.76,2.77,5.76,6.4v.54h-9.37a3.9,3.9,0,0,0,4,3.68,5,5,0,0,0,3.5-1.4l1,1.45a6.67,6.67,0,0,1-4.76,1.76,6.22,6.22,0,0,1-.19-12.43Zm-3.63,5.34h7.23a3.51,3.51,0,0,0-3.6-3.53A3.63,3.63,0,0,0,200.49,274.79Z"
      />
      <path
        className={classes.cls3}
        d="M219,278.42a5.72,5.72,0,0,0,4,1.7c1.67,0,2.55-.69,2.55-1.7,0-1.17-1.35-1.57-2.87-1.91-2-.46-4.36-1-4.36-3.55,0-1.89,1.61-3.51,4.51-3.51a6.33,6.33,0,0,1,4.51,1.69l-1,1.55a4.6,4.6,0,0,0-3.51-1.45c-1.49,0-2.43.59-2.43,1.54s1.28,1.38,2.75,1.72c2.06.47,4.51,1,4.51,3.75,0,2-1.67,3.63-4.78,3.63a6.72,6.72,0,0,1-4.93-1.84Z"
      />
      <path
        className={classes.cls3}
        d="M230.1,266.36a1.43,1.43,0,0,1,1.42-1.42,1.41,1.41,0,1,1-1.42,1.42Zm.34,15.23V269.74h2.21v11.85Z"
      />
      <path
        className={classes.cls3}
        d="M250.55,281.59v-7.9c0-1.37-.62-2.28-2.06-2.28a3.8,3.8,0,0,0-2.94,1.69v8.49h-2.21v-7.9c0-1.37-.59-2.28-2.09-2.28a3.87,3.87,0,0,0-2.89,1.72v8.46h-2.21V269.74h2.21v1.67a5.15,5.15,0,0,1,3.83-2,3.06,3.06,0,0,1,3.21,2.21,4.94,4.94,0,0,1,4-2.21c2.18,0,3.35,1.2,3.35,3.58v8.56Z"
      />
      <path
        className={classes.cls3}
        d="M258.46,286.1h-2.21V269.74h2.21v1.7a4.83,4.83,0,0,1,3.88-2c3.09,0,5.27,2.33,5.27,6.2s-2.18,6.23-5.27,6.23a4.73,4.73,0,0,1-3.88-2Zm3.29-14.69a4.08,4.08,0,0,0-3.29,1.74v5a4.13,4.13,0,0,0,3.29,1.74c2.2,0,3.55-1.79,3.55-4.27S264,271.41,261.75,271.41Z"
      />
      <path className={classes.cls3} d="M270.4,281.59V265.23h2.21v16.36Z" />
      <path
        className={classes.cls3}
        d="M275.77,266.36a1.42,1.42,0,1,1,2.84,0,1.42,1.42,0,0,1-2.84,0Zm.34,15.23V269.74h2.21v11.85Z"
      />
      <path
        className={classes.cls3}
        d="M287.12,269.45a5.15,5.15,0,0,1,4.43,2.08l-1.47,1.35a3.31,3.31,0,0,0-2.87-1.47c-2.32,0-3.82,1.79-3.82,4.24s1.5,4.27,3.82,4.27a3.36,3.36,0,0,0,2.87-1.47l1.47,1.35a5.15,5.15,0,0,1-4.43,2.08,6.22,6.22,0,0,1,0-12.43Z"
      />
      <path
        className={classes.cls3}
        d="M293.63,266.36a1.44,1.44,0,0,1,1.43-1.42,1.41,1.41,0,1,1-1.43,1.42Zm.35,15.23V269.74h2.21v11.85Z"
      />
      <path
        className={classes.cls3}
        d="M300.13,279v-7.28h-2v-1.94h2v-3.23h2.21v3.23h2.4v1.94h-2.4v6.79c0,.84.39,1.45,1.15,1.45a1.68,1.68,0,0,0,1.2-.47l.57,1.67a3.17,3.17,0,0,1-2.31.76C301.09,281.88,300.13,280.83,300.13,279Z"
      />
      <path
        className={classes.cls3}
        d="M307,284.24a2.67,2.67,0,0,0,1,.19,1.63,1.63,0,0,0,1.71-1.15l.69-1.57-4.88-12h2.35l3.71,9.3,3.7-9.3h2.38l-5.84,14.1a3.73,3.73,0,0,1-3.78,2.55,6.34,6.34,0,0,1-1.37-.17Z"
      />
      <path
        className={classes.cls3}
        d="M325,275.65a6,6,0,1,1,12,0c0,3.44-2.28,6.23-6,6.23A5.89,5.89,0,0,1,325,275.65Zm9.66,0c0-2.23-1.3-4.24-3.68-4.24s-3.67,2-3.67,4.24,1.32,4.27,3.67,4.27S334.62,277.91,334.62,275.65Z"
      />
      <path
        className={classes.cls3}
        d="M342.46,271.68v9.91h-2.2v-9.91h-2v-1.94h2V269c0-2.55,1.49-4,3.6-4a3.84,3.84,0,0,1,1.94.44l-.51,1.64a2.17,2.17,0,0,0-1.06-.27c-1.1,0-1.77.74-1.77,2.16v.78h2.41v1.94Z"
      />
      <path
        className={classes.cls3}
        d="M58.66,305.44c3.55,0,5.76,2.78,5.76,6.4v.54H55.05a3.89,3.89,0,0,0,4,3.68,5,5,0,0,0,3.5-1.4l1,1.45a6.65,6.65,0,0,1-4.75,1.77,6.22,6.22,0,0,1-.2-12.44ZM55,310.79h7.23a3.5,3.5,0,0,0-3.6-3.53A3.62,3.62,0,0,0,55,310.79Z"
      />
      <path
        className={classes.cls3}
        d="M81.58,317.58v-7.89c0-1.38-.61-2.28-2.06-2.28a3.8,3.8,0,0,0-2.94,1.69v8.48H74.37v-7.89c0-1.38-.59-2.28-2.08-2.28a3.84,3.84,0,0,0-2.89,1.71v8.46H67.19V305.74H69.4v1.67a5.11,5.11,0,0,1,3.82-2,3.07,3.07,0,0,1,3.21,2.21,5,5,0,0,1,4-2.21c2.18,0,3.36,1.21,3.36,3.58v8.56Z"
      />
      <path
        className={classes.cls3}
        d="M94.6,317.58v-1.3a5.1,5.1,0,0,1-3.88,1.6A3.94,3.94,0,0,1,86.6,314a3.83,3.83,0,0,1,4.12-3.87,4.93,4.93,0,0,1,3.88,1.57v-2c0-1.47-1.21-2.36-2.9-2.36a4.84,4.84,0,0,0-3.55,1.57l-1-1.52a6.65,6.65,0,0,1,4.86-1.94c2.57,0,4.75,1.13,4.75,4.15v8Zm0-4.61a3.78,3.78,0,0,0-3-1.35,2.38,2.38,0,1,0,0,4.71,3.75,3.75,0,0,0,3-1.35Z"
      />
      <path
        className={classes.cls3}
        d="M100,302.35a1.42,1.42,0,0,1,2.84,0,1.42,1.42,0,0,1-2.84,0Zm.34,15.23V305.74h2.21v11.84Z"
      />
      <path className={classes.cls3} d="M106,317.58V301.23h2.21v16.35Z" />
      <path
        className={classes.cls3}
        d="M128.35,317.58l-2.92-9.09-2.92,9.09h-2.28l-3.72-11.84h2.3l2.7,9,3-9h1.91l3,9,2.69-9h2.31l-3.73,11.84Z"
      />
      <path
        className={classes.cls3}
        d="M136,302.35a1.44,1.44,0,0,1,1.42-1.42,1.42,1.42,0,0,1,1.42,1.42,1.4,1.4,0,0,1-1.42,1.4A1.41,1.41,0,0,1,136,302.35Zm.34,15.23V305.74h2.21v11.84Z"
      />
      <path
        className={classes.cls3}
        d="M142.47,315v-7.28h-2v-1.94h2V302.5h2.2v3.24h2.41v1.94h-2.41v6.79c0,.83.39,1.45,1.16,1.45a1.73,1.73,0,0,0,1.2-.47l.56,1.67a3.15,3.15,0,0,1-2.3.76C143.42,317.88,142.47,316.82,142.47,315Z"
      />
      <path
        className={classes.cls3}
        d="M157.52,317.58V310c0-2-1-2.55-2.53-2.55a4.24,4.24,0,0,0-3.26,1.71v8.46h-2.2V301.23h2.2v6.18a5.69,5.69,0,0,1,4.19-2c2.53,0,3.81,1.28,3.81,3.78v8.36Z"
      />
      <path
        className={classes.cls3}
        d="M170,315v-7.28h-2v-1.94h2V302.5h2.21v3.24h2.4v1.94h-2.4v6.79c0,.83.39,1.45,1.15,1.45a1.73,1.73,0,0,0,1.2-.47l.56,1.67a3.13,3.13,0,0,1-2.3.76C171,317.88,170,316.82,170,315Z"
      />
      <path
        className={classes.cls3}
        d="M185.07,317.58V310c0-2-1-2.55-2.52-2.55a4.21,4.21,0,0,0-3.26,1.71v8.46h-2.21V301.23h2.21v6.18a5.66,5.66,0,0,1,4.19-2c2.52,0,3.8,1.28,3.8,3.78v8.36Z"
      />
      <path
        className={classes.cls3}
        d="M196,305.44c3.56,0,5.77,2.78,5.77,6.4v.54H192.4a3.88,3.88,0,0,0,4,3.68,5,5,0,0,0,3.51-1.4l1,1.45a6.69,6.69,0,0,1-4.76,1.77,6.22,6.22,0,0,1-.2-12.44Zm-3.62,5.35h7.23a3.51,3.51,0,0,0-3.61-3.53A3.61,3.61,0,0,0,192.38,310.79Z"
      />
      <path
        className={classes.cls3}
        d="M213.06,322.09h-2.2V305.74h2.2v1.69a4.83,4.83,0,0,1,3.88-2c3.09,0,5.27,2.33,5.27,6.21s-2.18,6.23-5.27,6.23a4.73,4.73,0,0,1-3.88-2Zm3.29-14.68a4.05,4.05,0,0,0-3.29,1.74v5a4.12,4.12,0,0,0,3.29,1.75c2.21,0,3.56-1.8,3.56-4.27S218.56,307.41,216.35,307.41Z"
      />
      <path
        className={classes.cls3}
        d="M225,317.58V305.74h2.21v1.81a5,5,0,0,1,3.87-2.08v2.23a3.39,3.39,0,0,0-.76-.07,4.17,4.17,0,0,0-3.11,1.71v8.24Z"
      />
      <path
        className={classes.cls3}
        d="M232.55,311.65a6,6,0,1,1,12,0c0,3.43-2.28,6.23-6,6.23A5.89,5.89,0,0,1,232.55,311.65Zm9.66,0c0-2.23-1.3-4.24-3.68-4.24s-3.67,2-3.67,4.24,1.32,4.27,3.67,4.27S242.21,313.9,242.21,311.65Z"
      />
      <path
        className={classes.cls3}
        d="M247.75,315v-7.28h-2v-1.94h2V302.5H250v3.24h2.4v1.94H250v6.79c0,.83.39,1.45,1.15,1.45a1.73,1.73,0,0,0,1.2-.47l.57,1.67a3.17,3.17,0,0,1-2.31.76A2.58,2.58,0,0,1,247.75,315Z"
      />
      <path
        className={classes.cls3}
        d="M260,305.44c3.55,0,5.76,2.78,5.76,6.4v.54H256.4a3.89,3.89,0,0,0,4,3.68,5,5,0,0,0,3.51-1.4l1,1.45a6.68,6.68,0,0,1-4.76,1.77,6.22,6.22,0,0,1-.19-12.44Zm-3.63,5.35h7.23a3.5,3.5,0,0,0-3.6-3.53A3.62,3.62,0,0,0,256.38,310.79Z"
      />
      <path
        className={classes.cls3}
        d="M273.83,305.44a5.19,5.19,0,0,1,4.44,2.09l-1.47,1.35a3.3,3.3,0,0,0-2.87-1.47c-2.33,0-3.82,1.79-3.82,4.24s1.49,4.27,3.82,4.27a3.38,3.38,0,0,0,2.87-1.48l1.47,1.35a5.19,5.19,0,0,1-4.44,2.09,6.22,6.22,0,0,1,0-12.44Z"
      />
      <path
        className={classes.cls3}
        d="M281.14,315v-7.28h-2v-1.94h2V302.5h2.2v3.24h2.41v1.94h-2.41v6.79c0,.83.4,1.45,1.16,1.45a1.73,1.73,0,0,0,1.2-.47l.56,1.67a3.13,3.13,0,0,1-2.3.76C282.09,317.88,281.14,316.82,281.14,315Z"
      />
      <path
        className={classes.cls3}
        d="M287.85,302.35a1.44,1.44,0,0,1,1.43-1.42,1.43,1.43,0,0,1,1.42,1.42,1.4,1.4,0,0,1-1.42,1.4A1.42,1.42,0,0,1,287.85,302.35Zm.35,15.23V305.74h2.2v11.84Z"
      />
      <path
        className={classes.cls3}
        d="M293.17,311.65a6,6,0,1,1,12,0c0,3.43-2.28,6.23-6,6.23A5.89,5.89,0,0,1,293.17,311.65Zm9.66,0c0-2.23-1.3-4.24-3.68-4.24s-3.67,2-3.67,4.24,1.32,4.27,3.67,4.27S302.83,313.9,302.83,311.65Z"
      />
      <path
        className={classes.cls3}
        d="M315.92,317.58V310c0-2-1-2.6-2.52-2.6a4.21,4.21,0,0,0-3.26,1.71v8.46h-2.21V305.74h2.21v1.67a5.62,5.62,0,0,1,4.19-2c2.5,0,3.8,1.33,3.8,3.83v8.31Z"
      />
      <path
        className={classes.cls3}
        d="M327.22,311.65a6,6,0,1,1,12,0c0,3.43-2.28,6.23-6,6.23A5.89,5.89,0,0,1,327.22,311.65Zm9.66,0c0-2.23-1.3-4.24-3.68-4.24s-3.67,2-3.67,4.24,1.32,4.27,3.67,4.27S336.88,313.9,336.88,311.65Z"
      />
      <path
        className={classes.cls3}
        d="M344.72,307.68v9.9h-2.2v-9.9h-2v-1.94h2V305c0-2.55,1.49-4,3.6-4a4,4,0,0,1,1.94.44l-.52,1.65a2,2,0,0,0-1.05-.27c-1.1,0-1.77.73-1.77,2.15v.79h2.41v1.94Z"
      />
      <path
        className={classes.cls3}
        d="M362.86,317.58v-1.3a5.07,5.07,0,0,1-3.87,1.6,3.94,3.94,0,0,1-4.12-3.93,3.82,3.82,0,0,1,4.12-3.87,4.91,4.91,0,0,1,3.87,1.57v-2c0-1.47-1.2-2.36-2.89-2.36a4.84,4.84,0,0,0-3.55,1.57l-1-1.52a6.64,6.64,0,0,1,4.85-1.94c2.58,0,4.76,1.13,4.76,4.15v8Zm0-4.61a3.75,3.75,0,0,0-3-1.35,2.38,2.38,0,1,0,0,4.71,3.72,3.72,0,0,0,3-1.35Z"
      />
      <path
        className={classes.cls3}
        d="M61.9,353.58v-1.69a4.93,4.93,0,0,1-3.88,2c-3.09,0-5.29-2.33-5.29-6.2s2.2-6.23,5.29-6.23a4.85,4.85,0,0,1,3.88,2v-6.23h2.2v16.36Zm0-8.44a4.13,4.13,0,0,0-3.29-1.74c-2.21,0-3.58,1.79-3.58,4.27s1.37,4.24,3.58,4.24a4.08,4.08,0,0,0,3.29-1.72Z"
      />
      <path
        className={classes.cls3}
        d="M66.89,347.64a6,6,0,1,1,12,0c0,3.44-2.28,6.23-6,6.23A5.89,5.89,0,0,1,66.89,347.64Zm9.66,0c0-2.23-1.3-4.24-3.67-4.24s-3.68,2-3.68,4.24,1.32,4.27,3.68,4.27S76.55,349.9,76.55,347.64Z"
      />
      <path
        className={classes.cls3}
        d="M87,341.44a5.15,5.15,0,0,1,4.43,2.08l-1.47,1.35A3.31,3.31,0,0,0,87,343.4c-2.32,0-3.82,1.79-3.82,4.24s1.5,4.27,3.82,4.27a3.36,3.36,0,0,0,2.87-1.47l1.47,1.35A5.15,5.15,0,0,1,87,353.87a6.22,6.22,0,0,1,0-12.43Z"
      />
      <path
        className={classes.cls3}
        d="M101.8,353.58V352a5.85,5.85,0,0,1-4.22,1.91c-2.52,0-3.77-1.27-3.77-3.77v-8.37H96v7.63c0,2,1,2.55,2.5,2.55a4.25,4.25,0,0,0,3.28-1.67v-8.51H104v11.85Z"
      />
      <path
        className={classes.cls3}
        d="M121.91,353.58v-7.9c0-1.37-.62-2.28-2.06-2.28a3.84,3.84,0,0,0-2.95,1.69v8.49h-2.2v-7.9c0-1.37-.59-2.28-2.09-2.28a3.87,3.87,0,0,0-2.89,1.72v8.46h-2.21V341.73h2.21v1.67a5.14,5.14,0,0,1,3.82-2,3.07,3.07,0,0,1,3.22,2.21,4.93,4.93,0,0,1,4-2.21c2.19,0,3.36,1.2,3.36,3.58v8.56Z"
      />
      <path
        className={classes.cls3}
        d="M132.81,341.44c3.56,0,5.76,2.77,5.76,6.4v.54h-9.36a3.88,3.88,0,0,0,4,3.68,5,5,0,0,0,3.5-1.4l1,1.45a6.64,6.64,0,0,1-4.75,1.76,6.22,6.22,0,0,1-.2-12.43Zm-3.63,5.35h7.24a3.52,3.52,0,0,0-3.61-3.54A3.63,3.63,0,0,0,129.18,346.79Z"
      />
      <path
        className={classes.cls3}
        d="M149.33,353.58V346c0-2-1-2.6-2.52-2.6a4.22,4.22,0,0,0-3.26,1.72v8.46h-2.21V341.73h2.21v1.67a5.65,5.65,0,0,1,4.19-2c2.5,0,3.8,1.32,3.8,3.83v8.31Z"
      />
      <path
        className={classes.cls3}
        d="M155.48,351v-7.28h-2v-1.94h2V338.5h2.21v3.23h2.4v1.94h-2.4v6.79c0,.84.39,1.45,1.15,1.45a1.66,1.66,0,0,0,1.2-.47l.57,1.67a3.16,3.16,0,0,1-2.31.76C156.44,353.87,155.48,352.82,155.48,351Z"
      />
      <path
        className={classes.cls3}
        d="M174.07,341.44c3.55,0,5.76,2.77,5.76,6.4v.54h-9.37a3.88,3.88,0,0,0,4,3.68,5,5,0,0,0,3.51-1.4l1,1.45a6.69,6.69,0,0,1-4.76,1.76,6.22,6.22,0,0,1-.19-12.43Zm-3.63,5.35h7.23a3.51,3.51,0,0,0-3.6-3.54A3.63,3.63,0,0,0,170.44,346.79Z"
      />
      <path
        className={classes.cls3}
        d="M189.29,353.58,186,349l-3.34,4.61h-2.5l4.44-6.08-4.17-5.77h2.5L186,346l3-4.27h2.5l-4.19,5.77,4.46,6.08Z"
      />
      <path
        className={classes.cls3}
        d="M198.36,341.44a5.19,5.19,0,0,1,4.44,2.08l-1.47,1.35a3.32,3.32,0,0,0-2.87-1.47c-2.33,0-3.83,1.79-3.83,4.24s1.5,4.27,3.83,4.27a3.37,3.37,0,0,0,2.87-1.47l1.47,1.35a5.19,5.19,0,0,1-4.44,2.08,6.22,6.22,0,0,1,0-12.43Z"
      />
      <path
        className={classes.cls3}
        d="M213.22,353.58V346c0-2-1-2.55-2.53-2.55a4.25,4.25,0,0,0-3.26,1.72v8.46h-2.21V337.22h2.21v6.18a5.71,5.71,0,0,1,4.19-2c2.53,0,3.8,1.28,3.8,3.78v8.36Z"
      />
      <path
        className={classes.cls3}
        d="M226.26,353.58v-1.3a5.09,5.09,0,0,1-3.88,1.59,3.93,3.93,0,0,1-4.12-3.92,3.83,3.83,0,0,1,4.12-3.88,5,5,0,0,1,3.88,1.57v-2c0-1.47-1.21-2.35-2.9-2.35a4.81,4.81,0,0,0-3.55,1.57l-1-1.52a6.65,6.65,0,0,1,4.86-1.94c2.57,0,4.75,1.13,4.75,4.14v8Zm0-4.61a3.78,3.78,0,0,0-3-1.35,2.38,2.38,0,1,0,0,4.71,3.78,3.78,0,0,0,3-1.35Z"
      />
      <path
        className={classes.cls3}
        d="M240,353.58V346c0-2-1-2.6-2.52-2.6a4.22,4.22,0,0,0-3.26,1.72v8.46H232V341.73h2.21v1.67a5.65,5.65,0,0,1,4.19-2c2.5,0,3.8,1.32,3.8,3.83v8.31Z"
      />
      <path
        className={classes.cls3}
        d="M246.65,355a4.61,4.61,0,0,0,3.8,1.57c1.84,0,3.68-.88,3.68-3.38v-1.55a5,5,0,0,1-3.9,2c-3.07,0-5.27-2.26-5.27-6.13s2.2-6.11,5.27-6.11a4.86,4.86,0,0,1,3.9,2v-1.72h2.2v11.38c0,4.07-3,5.27-5.88,5.27a6.37,6.37,0,0,1-4.86-1.76Zm7.48-9.86a4.14,4.14,0,0,0-3.29-1.74c-2.2,0-3.58,1.72-3.58,4.15s1.38,4.16,3.58,4.16a4.13,4.13,0,0,0,3.29-1.76Z"
      />
      <path
        className={classes.cls3}
        d="M265,341.44c3.55,0,5.76,2.77,5.76,6.4v.54h-9.37a3.88,3.88,0,0,0,4,3.68,5,5,0,0,0,3.51-1.4l1,1.45a6.69,6.69,0,0,1-4.76,1.76,6.22,6.22,0,0,1-.19-12.43Zm-3.63,5.35h7.23a3.51,3.51,0,0,0-3.6-3.54A3.63,3.63,0,0,0,261.41,346.79Z"
      />
      <path
        className={classes.cls3}
        d="M282.1,358.09h-2.21V341.73h2.21v1.7a4.82,4.82,0,0,1,3.87-2c3.09,0,5.27,2.33,5.27,6.2s-2.18,6.23-5.27,6.23a4.71,4.71,0,0,1-3.87-2Zm3.28-14.69a4,4,0,0,0-3.28,1.74v5a4.1,4.1,0,0,0,3.28,1.74c2.21,0,3.56-1.79,3.56-4.27S287.59,343.4,285.38,343.4Z"
      />
      <path
        className={classes.cls3}
        d="M293.3,347.64a6,6,0,1,1,12,0c0,3.44-2.28,6.23-6,6.23S293.3,351.08,293.3,347.64Zm9.66,0c0-2.23-1.3-4.24-3.68-4.24s-3.68,2-3.68,4.24,1.33,4.27,3.68,4.27S303,349.9,303,347.64Z"
      />
      <path
        className={classes.cls3}
        d="M308.05,353.58V341.73h2.21v1.82a5,5,0,0,1,3.88-2.09v2.24a3.41,3.41,0,0,0-.76-.08,4.21,4.21,0,0,0-3.12,1.72v8.24Z"
      />
      <path
        className={classes.cls3}
        d="M316.78,351v-7.28h-2v-1.94h2V338.5H319v3.23h2.4v1.94H319v6.79c0,.84.39,1.45,1.15,1.45a1.66,1.66,0,0,0,1.2-.47l.57,1.67a3.17,3.17,0,0,1-2.31.76C317.74,353.87,316.78,352.82,316.78,351Z"
      />
      <path
        className={classes.cls3}
        d="M331.15,353.58v-1.3a5.07,5.07,0,0,1-3.88,1.59,3.93,3.93,0,0,1-4.12-3.92,3.83,3.83,0,0,1,4.12-3.88,5,5,0,0,1,3.88,1.57v-2c0-1.47-1.2-2.35-2.9-2.35a4.82,4.82,0,0,0-3.55,1.57l-1-1.52a6.68,6.68,0,0,1,4.86-1.94c2.57,0,4.75,1.13,4.75,4.14v8Zm0-4.61a3.76,3.76,0,0,0-3-1.35,2.38,2.38,0,1,0,0,4.71,3.76,3.76,0,0,0,3-1.35Z"
      />
      <path className={classes.cls3} d="M336.88,353.58V337.22h2.21v16.36Z" />
      <path
        className={classes.cls3}
        d="M349.36,351v-7.28h-2v-1.94h2V338.5h2.21v3.23H354v1.94h-2.4v6.79c0,.84.39,1.45,1.15,1.45a1.68,1.68,0,0,0,1.2-.47l.56,1.67a3.13,3.13,0,0,1-2.3.76C350.31,353.87,349.36,352.82,349.36,351Z"
      />
      <path
        className={classes.cls3}
        d="M355.68,347.64a6,6,0,1,1,12,0c0,3.44-2.28,6.23-6,6.23A5.89,5.89,0,0,1,355.68,347.64Zm9.66,0c0-2.23-1.3-4.24-3.67-4.24s-3.68,2-3.68,4.24,1.32,4.27,3.68,4.27S365.34,349.9,365.34,347.64Z"
      />
      <path
        className={classes.cls3}
        d="M53.9,387v-7.28h-2v-1.94h2v-3.24h2.21v3.24h2.4v1.94h-2.4v6.79c0,.83.39,1.45,1.15,1.45a1.66,1.66,0,0,0,1.2-.47l.57,1.67a3.16,3.16,0,0,1-2.31.76A2.58,2.58,0,0,1,53.9,387Z"
      />
      <path
        className={classes.cls3}
        d="M61,389.57V377.73h2.21v1.81A5,5,0,0,1,67,377.46v2.23a3.39,3.39,0,0,0-.76-.07,4.17,4.17,0,0,0-3.11,1.71v8.24Z"
      />
      <path
        className={classes.cls3}
        d="M76.55,389.57v-1.3a5.07,5.07,0,0,1-3.87,1.6,3.94,3.94,0,0,1-4.12-3.93,3.82,3.82,0,0,1,4.12-3.87,4.91,4.91,0,0,1,3.87,1.57v-2c0-1.47-1.2-2.36-2.89-2.36a4.84,4.84,0,0,0-3.55,1.57l-1-1.52A6.64,6.64,0,0,1,74,377.44c2.58,0,4.76,1.12,4.76,4.14v8Zm0-4.61a3.75,3.75,0,0,0-3-1.35,2.38,2.38,0,1,0,0,4.71,3.72,3.72,0,0,0,3-1.35Z"
      />
      <path
        className={classes.cls3}
        d="M90.28,389.57V382c0-2-1-2.6-2.52-2.6a4.21,4.21,0,0,0-3.26,1.71v8.46H82.29V377.73H84.5v1.67a5.62,5.62,0,0,1,4.19-2c2.5,0,3.8,1.32,3.8,3.82v8.31Z"
      />
      <path
        className={classes.cls3}
        d="M96,386.41a5.73,5.73,0,0,0,4,1.69c1.67,0,2.55-.68,2.55-1.69,0-1.18-1.35-1.57-2.87-1.91-2-.47-4.37-1-4.37-3.56,0-1.89,1.62-3.5,4.52-3.5a6.33,6.33,0,0,1,4.51,1.69l-1,1.54a4.63,4.63,0,0,0-3.51-1.44c-1.5,0-2.43.58-2.43,1.54s1.28,1.37,2.75,1.72c2.06.46,4.51,1,4.51,3.75,0,2-1.67,3.63-4.78,3.63A6.76,6.76,0,0,1,95,388Z"
      />
      <path
        className={classes.cls3}
        d="M110.21,379.67v9.9H108v-9.9h-2v-1.94h2V377c0-2.56,1.5-4,3.61-4a3.91,3.91,0,0,1,1.93.44l-.51,1.65a2,2,0,0,0-1.06-.27c-1.1,0-1.76.73-1.76,2.16v.78h2.4v1.94Z"
      />
      <path
        className={classes.cls3}
        d="M119.92,377.44c3.55,0,5.76,2.77,5.76,6.39v.55h-9.37a3.88,3.88,0,0,0,4,3.67,5.06,5.06,0,0,0,3.51-1.39l1,1.44a6.68,6.68,0,0,1-4.76,1.77,6.22,6.22,0,0,1-.19-12.43Zm-3.63,5.34h7.23a3.5,3.5,0,0,0-3.6-3.53A3.62,3.62,0,0,0,116.29,382.78Z"
      />
      <path
        className={classes.cls3}
        d="M128.45,389.57V377.73h2.2v1.81a5.06,5.06,0,0,1,3.88-2.08v2.23a3.45,3.45,0,0,0-.76-.07,4.19,4.19,0,0,0-3.12,1.71v8.24Z"
      />
      <path
        className={classes.cls3}
        d="M145.8,389.57h-2.21v-9.9h-2v-1.94h2V377c0-2.56,1.5-4,3.61-4a4,4,0,0,1,1.94.44l-.52,1.65a1.84,1.84,0,0,0-1.05-.27c-1.11,0-1.77.73-1.77,2.16v.78h2.41v1.94H145.8ZM150,374.35a1.44,1.44,0,0,1,1.42-1.43,1.42,1.42,0,0,1,1.42,1.43,1.39,1.39,0,0,1-1.42,1.39A1.41,1.41,0,0,1,150,374.35Zm.34,15.22V377.73h2.21v11.84Z"
      />
      <path className={classes.cls3} d="M156,389.57V373.22h2.21v16.35Z" />
      <path
        className={classes.cls3}
        d="M166.93,377.44c3.56,0,5.77,2.77,5.77,6.39v.55h-9.37a3.87,3.87,0,0,0,4,3.67,5.08,5.08,0,0,0,3.51-1.39l1,1.44a6.69,6.69,0,0,1-4.76,1.77,6.22,6.22,0,0,1-.2-12.43Zm-3.63,5.34h7.24a3.51,3.51,0,0,0-3.61-3.53A3.63,3.63,0,0,0,163.3,382.78Z"
      />
      <path
        className={classes.cls3}
        d="M175.49,386.41a5.75,5.75,0,0,0,4,1.69c1.67,0,2.55-.68,2.55-1.69,0-1.18-1.35-1.57-2.87-1.91-2-.47-4.36-1-4.36-3.56,0-1.89,1.61-3.5,4.51-3.5a6.33,6.33,0,0,1,4.51,1.69l-1,1.54a4.63,4.63,0,0,0-3.51-1.44c-1.49,0-2.43.58-2.43,1.54s1.28,1.37,2.75,1.72c2.06.46,4.51,1,4.51,3.75,0,2-1.67,3.63-4.78,3.63a6.76,6.76,0,0,1-4.93-1.84Z"
      />
      <path
        className={classes.cls3}
        d="M193.28,386.41a5.75,5.75,0,0,0,4,1.69c1.67,0,2.55-.68,2.55-1.69,0-1.18-1.34-1.57-2.86-1.91-2-.47-4.37-1-4.37-3.56,0-1.89,1.62-3.5,4.51-3.5a6.3,6.3,0,0,1,4.51,1.69l-1,1.54a4.61,4.61,0,0,0-3.5-1.44c-1.5,0-2.43.58-2.43,1.54s1.28,1.37,2.75,1.72c2.06.46,4.51,1,4.51,3.75,0,2-1.67,3.63-4.78,3.63a6.76,6.76,0,0,1-4.93-1.84Z"
      />
      <path
        className={classes.cls3}
        d="M209.93,377.44c3.55,0,5.76,2.77,5.76,6.39v.55h-9.37a3.89,3.89,0,0,0,4,3.67,5,5,0,0,0,3.51-1.39l1,1.44a6.68,6.68,0,0,1-4.76,1.77,6.22,6.22,0,0,1-.19-12.43Zm-3.63,5.34h7.23a3.5,3.5,0,0,0-3.6-3.53A3.62,3.62,0,0,0,206.3,382.78Z"
      />
      <path
        className={classes.cls3}
        d="M223.75,377.44a5.19,5.19,0,0,1,4.44,2.08l-1.47,1.35a3.3,3.3,0,0,0-2.87-1.47c-2.33,0-3.82,1.79-3.82,4.24s1.49,4.27,3.82,4.27a3.35,3.35,0,0,0,2.87-1.48l1.47,1.35a5.17,5.17,0,0,1-4.44,2.09,6.22,6.22,0,0,1,0-12.43Z"
      />
      <path
        className={classes.cls3}
        d="M238.61,389.57V388a5.85,5.85,0,0,1-4.22,1.91c-2.52,0-3.77-1.28-3.77-3.78v-8.36h2.2v7.63c0,2,1,2.55,2.5,2.55a4.29,4.29,0,0,0,3.29-1.67v-8.51h2.21v11.84Z"
      />
      <path
        className={classes.cls3}
        d="M244.32,389.57V377.73h2.21v1.81a5,5,0,0,1,3.87-2.08v2.23a3.45,3.45,0,0,0-.76-.07,4.17,4.17,0,0,0-3.11,1.71v8.24Z"
      />
      <path
        className={classes.cls3}
        d="M257.8,377.44c3.56,0,5.76,2.77,5.76,6.39v.55H254.2a3.87,3.87,0,0,0,4,3.67,5.08,5.08,0,0,0,3.51-1.39l1,1.44a6.65,6.65,0,0,1-4.75,1.77,6.22,6.22,0,0,1-.2-12.43Zm-3.63,5.34h7.24a3.51,3.51,0,0,0-3.61-3.53A3.62,3.62,0,0,0,254.17,382.78Z"
      />
      <path className={classes.cls3} d="M266.33,389.57V373.22h2.21v16.35Z" />
      <path
        className={classes.cls3}
        d="M271.8,392.22a2.72,2.72,0,0,0,1,.2,1.62,1.62,0,0,0,1.71-1.15l.69-1.57-4.88-12h2.36l3.7,9.29,3.7-9.29h2.38l-5.84,14.1a3.75,3.75,0,0,1-3.77,2.55,6.36,6.36,0,0,1-1.38-.17Z"
      />
      <path
        className={classes.cls5}
        d="M220.4,696.37q-3,0-6.11-.09c-33.76-1-65.62-10.08-92.15-26.28a138.26,138.26,0,0,1-58.59-72.79,148.74,148.74,0,0,1-8.15-52.38c.74-20.28,6.27-37.2,16.44-50.27,20.54-26.39,50.33-16.47,74-4.88,42.5,20.81,65.74,17.22,84.54,10.23,13.11-4.87,25-13.21,36.52-21.26,14.2-9.94,28.89-20.22,46.06-24.21,15.7-3.65,32.18-.66,46.43,8.4a75.94,75.94,0,0,1,30,37.67c11.58,31.32,8.47,67.17-8.75,101C365,632.22,338.81,659,308.87,675,282.68,689,252.21,696.37,220.4,696.37ZM105.17,479.92c-11.53,0-22.44,4.28-31.57,16-14.27,18.33-23.85,54.38-7.94,100.55A136.07,136.07,0,0,0,123.3,668.1c26.2,16,57.68,25,91.05,25.95,33.63,1,66-6.27,93.47-21,29.55-15.79,55.37-42.26,70.85-72.62,16.93-33.22,20-68.44,8.63-99.16a73.63,73.63,0,0,0-29.1-36.57c-13.74-8.74-29.62-11.62-44.73-8.11-16.76,3.9-31.26,14.05-45.29,23.86-11.63,8.14-23.65,16.56-37,21.53-32.58,12.12-60.73,2.2-86.29-10.32C132,485.37,118.17,479.92,105.17,479.92Z"
      />
      <g className={classes.cls6}>
        <path
          className={classes.cls4}
          d="M359.5,449.19C338.6,423.78,302.1,413,273.64,431c-26.79,16.9-38.77,50-63,70-25.38,21-53.33,22.06-84.06,18.32-26.49-3.22-56.64-2.72-67.11,28.14-11.35,33.46,5.4,72.84,25.67,98.64a136.63,136.63,0,0,0,78.58,49.14c61.23,13.29,133.38-8.94,177-56.18C385.84,590.18,405.08,504.58,359.5,449.19Z"
        />
      </g>
      <path
        className={classes.cls7}
        d="M225,461l-93.87,80.65,1.75,36.49c0,4.35,5.25,66.07,10.24,66.07l87.66-58.66,79,52.63c5,0,14.64-57.34,14.64-61.7l5.84-34.91-94-80.57A10.1,10.1,0,0,0,225,461Z"
      />
      <rect
        className={classes.cls8}
        x="147.46"
        y="489.89"
        width="166.07"
        height="168.89"
        rx="7.31"
      />
      <path
        className={classes.cls5}
        d="M197.63,588.27h-35.2A2.48,2.48,0,0,1,160,585.8V550.6a2.47,2.47,0,0,1,2.47-2.47h35.2a2.47,2.47,0,0,1,2.47,2.47v35.2A2.48,2.48,0,0,1,197.63,588.27Zm-32.73-4.94h30.26V553.07H164.9Z"
      />
      <path
        className={classes.cls9}
        d="M305.33,578.64H217.48a2.47,2.47,0,1,1,0-4.94h87.85a2.47,2.47,0,1,1,0,4.94Z"
      />
      <path
        className={classes.cls10}
        d="M177.63,580.29h-.06a2.47,2.47,0,0,1-2.14-1.34l-4.3-8.4a2.47,2.47,0,1,1,4.39-2.25l2.23,4.36,8.83-15.32a2.47,2.47,0,1,1,4.27,2.47l-11.08,19.24A2.47,2.47,0,0,1,177.63,580.29Z"
      />
      <rect
        className={classes.cls5}
        x="215.01"
        y="557.76"
        width="49.08"
        height="4.9"
        rx="2.45"
      />
      <path
        className={classes.cls5}
        d="M197.63,542.51h-35.2A2.47,2.47,0,0,1,160,540v-35.2a2.48,2.48,0,0,1,2.47-2.47h35.2a2.48,2.48,0,0,1,2.47,2.47V540A2.47,2.47,0,0,1,197.63,542.51Zm-32.73-4.94h30.26V507.31H164.9Z"
      />
      <path
        className={classes.cls5}
        d="M284.34,516.94H217.17a2.49,2.49,0,0,1,0-4.94h67.17a2.49,2.49,0,0,1,0,4.94Z"
      />
      <path
        className={classes.cls9}
        d="M300.05,532.88H217.33a2.47,2.47,0,0,1,0-4.94h82.72a2.47,2.47,0,0,1,0,4.94Z"
      />
      <path
        className={classes.cls10}
        d="M177.63,534.53h-.06a2.45,2.45,0,0,1-2.14-1.34l-4.3-8.39a2.47,2.47,0,1,1,4.39-2.26l2.23,4.36,8.83-15.31a2.46,2.46,0,1,1,4.27,2.46L179.77,533.3A2.48,2.48,0,0,1,177.63,534.53Z"
      />
      <path
        className={classes.cls11}
        d="M232.74,602.64,278,558.07c11.89-11.7,28.87-18.39,46.69-18.39h0c4.19,0,7.58,2.66,7.58,5.94V664.74c0,3.28-5.66,8.26-9.84,8.26H296.73l-64-63A5.07,5.07,0,0,1,232.74,602.64Z"
      />
      <path
        className={classes.cls11}
        d="M228.89,602.56,183.6,558c-11.9-11.7-28.88-18.39-46.7-18.39h0c-4.18,0-7.58,2.66-7.58,5.94V665.37c0,3.28,4.86,7.63,9.05,7.63l26.53-.08,64-63A5.07,5.07,0,0,0,228.89,602.56Z"
      />
      <path
        className={classes.cls12}
        d="M332.31,640.36v25.69c0,3.84-4.05,7-9,7H138.36c-5,0-9-3.11-9-7V640.36l95.86-58.71a11.24,11.24,0,0,1,11.27,0Z"
      />
      <polygon
        className={classes.cls7}
        points="248.77 586.79 332.31 629.43 332.31 640.36 247.26 588.27 248.77 586.79"
      />
      <polygon
        className={classes.cls7}
        points="212.87 586.79 129.32 629.43 129.32 640.36 214.37 588.27 212.87 586.79"
      />
      <polygon
        className={classes.cls13}
        points="183.08 470.63 163.49 534.26 160.35 544.46 151.4 536.9 128.01 517.17 183.08 470.63"
      />
      <polygon
        className={classes.cls11}
        points="183.08 470.63 115.01 509.94 84.05 499.68 183.08 470.63"
      />
      <polygon
        className={classes.cls7}
        points="183.08 470.63 128.01 517.17 117.42 538.33 115.01 509.94 183.08 470.63"
      />
      <path
        className={classes.cls9}
        d="M203.65,686a1.19,1.19,0,0,1-.32-.05c-2.27-.68-4.55-1.45-6.78-2.31a1.11,1.11,0,1,1,.8-2.08c2.17.84,4.4,1.59,6.62,2.25a1.12,1.12,0,0,1-.32,2.19Zm-15.33-6.1a1.11,1.11,0,0,1-.5-.12c-2.12-1.07-4.23-2.23-6.27-3.46a1.13,1.13,0,0,1-.38-1.53,1.11,1.11,0,0,1,1.53-.38c2,1.2,4.05,2.33,6.13,3.38a1.12,1.12,0,0,1-.51,2.11Zm-14-8.69a1.12,1.12,0,0,1-.67-.22c-1.9-1.42-3.78-2.94-5.57-4.5a1.16,1.16,0,0,1-.36-.62,32.68,32.68,0,0,1-3.19.94,1.12,1.12,0,0,1-.52-2.17,29.68,29.68,0,0,0,6.39-2.33,1.12,1.12,0,0,1,1,2c-.52.26-1,.51-1.59.74,1.66,1.45,3.4,2.84,5.17,4.17a1.11,1.11,0,0,1-.67,2Zm-19.41-3.49h-.06a40.26,40.26,0,0,1-7.19-1,1.11,1.11,0,1,1,.5-2.17,37.71,37.71,0,0,0,6.8,1,1.12,1.12,0,0,1-.05,2.23Zm-15.92-4a1.23,1.23,0,0,1-.46-.1,63,63,0,0,1-6.39-3.33,1.12,1.12,0,0,1,1.14-1.92,59.54,59.54,0,0,0,6.16,3.21,1.12,1.12,0,0,1-.45,2.14ZM162,660.18a1.11,1.11,0,0,1-.82-.36,45.94,45.94,0,0,1-4.48-5.7,1.11,1.11,0,0,1,.31-1.54,1.12,1.12,0,0,1,1.55.31,43.13,43.13,0,0,0,4.26,5.42,1.11,1.11,0,0,1-.07,1.58A1.07,1.07,0,0,1,162,660.18Zm16.39-1.39a1.07,1.07,0,0,1-.75-.29,1.13,1.13,0,0,1-.07-1.58,20.71,20.71,0,0,0,1.92-2.39,18.9,18.9,0,0,0,1.79-3.17,1.11,1.11,0,1,1,2,.91,20.77,20.77,0,0,1-2,3.54,23.72,23.72,0,0,1-2.11,2.62A1.11,1.11,0,0,1,178.41,658.79Zm-53.49-3.72a1.12,1.12,0,0,1-.69-.23c-1.87-1.47-3.7-3.05-5.43-4.69a1.11,1.11,0,1,1,1.53-1.62c1.69,1.59,3.46,3.13,5.28,4.55a1.12,1.12,0,0,1,.19,1.57A1.11,1.11,0,0,1,124.92,655.07Zm28.59-8.9a1.11,1.11,0,0,1-1.06-.78,21.59,21.59,0,0,1-1-6.31c0-.36,0-.72,0-1.07a1.11,1.11,0,0,1,2.22.14c0,.3,0,.61,0,.93a19.17,19.17,0,0,0,.91,5.65,1.11,1.11,0,0,1-.74,1.39A1,1,0,0,1,153.51,646.17Zm30.73-2.41a1.12,1.12,0,0,1-1.12-1.11,19.54,19.54,0,0,0-1.13-6.57,1.12,1.12,0,1,1,2.1-.76,21.74,21.74,0,0,1,1.26,7.32,1.11,1.11,0,0,1-1.11,1.12Zm-71.13-.19a1.13,1.13,0,0,1-.86-.4c-1.52-1.83-3-3.75-4.34-5.71a1.12,1.12,0,1,1,1.84-1.27c1.32,1.9,2.74,3.77,4.22,5.55a1.11,1.11,0,0,1-.15,1.57A1.08,1.08,0,0,1,113.11,643.57Zm42.94-13a1.07,1.07,0,0,1-.74-.29,1.1,1.1,0,0,1-.08-1.57,15.1,15.1,0,0,1,6.35-4.1,1.11,1.11,0,1,1,.72,2.11,13,13,0,0,0-5.42,3.48A1.09,1.09,0,0,1,156.05,630.61Zm-52.12-.73a1.11,1.11,0,0,1-1-.6c-1.12-2.11-2.16-4.29-3.08-6.48a1.12,1.12,0,0,1,2.06-.86c.89,2.13,1.9,4.25,3,6.3a1.12,1.12,0,0,1-.47,1.51A1.18,1.18,0,0,1,103.93,629.88Zm73.72-.65A1.09,1.09,0,0,1,177,629,15.11,15.11,0,0,0,171,626.3a1.12,1.12,0,1,1,.47-2.18,17.25,17.25,0,0,1,6.84,3.11,1.11,1.11,0,0,1,.2,1.56A1.13,1.13,0,0,1,177.65,629.23ZM97.77,614.59a1.11,1.11,0,0,1-1.07-.81c-.66-2.31-1.21-4.66-1.65-7a1.12,1.12,0,0,1,2.2-.41c.42,2.27,1,4.55,1.59,6.79a1.1,1.1,0,0,1-.77,1.37A1,1,0,0,1,97.77,614.59ZM95,598.34a1.12,1.12,0,0,1-1.11-1.05c-.09-1.51-.13-3-.13-4.55,0-.87,0-1.76,0-2.63a1.12,1.12,0,1,1,2.23.07c0,.85,0,1.71,0,2.56,0,1.47,0,3,.13,4.42a1.12,1.12,0,0,1-1,1.17Zm.8-16.47h-.18a1.13,1.13,0,0,1-.93-1.28c.36-2.35.84-4.72,1.41-7a1.11,1.11,0,1,1,2.16.53c-.55,2.25-1,4.55-1.36,6.84A1.12,1.12,0,0,1,95.81,581.87Zm4.16-16a1.34,1.34,0,0,1-.39-.07,1.11,1.11,0,0,1-.65-1.44c.84-2.24,1.78-4.46,2.81-6.6a1.12,1.12,0,0,1,1.49-.52,1.11,1.11,0,0,1,.52,1.49c-1,2.08-1.92,4.24-2.73,6.41A1.13,1.13,0,0,1,100,565.92Zm7.37-14.75a1.12,1.12,0,0,1-.94-1.72c1.3-2,2.69-4,4.15-5.85a1.12,1.12,0,1,1,1.76,1.37c-1.42,1.81-2.77,3.73-4,5.69A1.11,1.11,0,0,1,107.34,551.17Z"
      />
      <path
        className={classes.cls9}
        d="M261.54,684.82l-.2,0a1.12,1.12,0,0,1-.9-1.29,30.84,30.84,0,0,1,2.14-7,1.11,1.11,0,1,1,2,.9,29,29,0,0,0-2,6.49A1.11,1.11,0,0,1,261.54,684.82Zm49.24-8.93h-.1a14.15,14.15,0,0,1-7.09-2.73,1.12,1.12,0,0,1,1.34-1.79,11.84,11.84,0,0,0,5.95,2.3,1.12,1.12,0,0,1-.1,2.23Zm8.31-3.5a1.07,1.07,0,0,1-.67-.23,1.11,1.11,0,0,1-.22-1.56A9.27,9.27,0,0,0,320,665v-.31a1.12,1.12,0,0,1,2.23-.06V665a11.55,11.55,0,0,1-2.19,7A1.14,1.14,0,0,1,319.09,672.39ZM268.46,670a1.09,1.09,0,0,1-.68-.24,1.13,1.13,0,0,1-.2-1.57,48.77,48.77,0,0,1,4.89-5.34,1.12,1.12,0,0,1,1.53,1.63,45.23,45.23,0,0,0-4.66,5.09A1.12,1.12,0,0,1,268.46,670Zm31.21-4.57a1.12,1.12,0,0,1-1.11-1c-.05-.5-.08-1-.08-1.53a15.87,15.87,0,0,1,1.2-5.94,1.13,1.13,0,0,1,1.46-.61,1.11,1.11,0,0,1,.61,1.45,13.48,13.48,0,0,0-1,5.1,11.15,11.15,0,0,0,.07,1.29,1.11,1.11,0,0,1-1,1.23Zm-19-6.45a1.13,1.13,0,0,1-.94-.51,1.12,1.12,0,0,1,.34-1.54,53.52,53.52,0,0,1,6.32-3.5,1.11,1.11,0,1,1,.94,2,52.65,52.65,0,0,0-6.05,3.35A1.14,1.14,0,0,1,280.67,659Zm37.07-1.91a1.1,1.1,0,0,1-.84-.39,12.19,12.19,0,0,0-1.25-1.24,15.67,15.67,0,0,0-4.09-2.46,1.11,1.11,0,0,1-.6-1.46,1.1,1.1,0,0,1,1.45-.6,17.9,17.9,0,0,1,4.68,2.82,14.06,14.06,0,0,1,1.5,1.49,1.12,1.12,0,0,1-.85,1.84Zm-22-4.65a1.13,1.13,0,0,1-1.09-.86,1.11,1.11,0,0,1,.83-1.34c.42-.1.84-.2,1.26-.28a32.56,32.56,0,0,1,6-.69,1.12,1.12,0,1,1,0,2.23,30.8,30.8,0,0,0-5.57.64l-1.19.26A.82.82,0,0,1,295.75,652.43Zm10.66-1.3a1.15,1.15,0,0,1-.89-.44,1.14,1.14,0,0,1,.21-1.57,18.63,18.63,0,0,1,3-1.85,24,24,0,0,1,3.71-1.43,1.12,1.12,0,0,1,.63,2.14,21.41,21.41,0,0,0-3.35,1.3,15.1,15.1,0,0,0-2.61,1.62A1.14,1.14,0,0,1,306.41,651.13ZM322,646.64a1.11,1.11,0,0,1-1.11-1,1.12,1.12,0,0,1,1.05-1.18c1.31-.07,2.63-.11,3.9-.16l.56,0c1.05,0,1.86-.07,2.62-.11a1.12,1.12,0,0,1,.12,2.23l-2.66.11-.56,0c-1.26,0-2.57.09-3.86.16Zm16.4-1.64a1.12,1.12,0,0,1-.31-2.19,19.73,19.73,0,0,0,4.85-2.06,10,10,0,0,0,1.1-.78,1.11,1.11,0,0,1,1.4,1.73,12.25,12.25,0,0,1-1.35,1,22.11,22.11,0,0,1-5.39,2.3A1.54,1.54,0,0,1,338.44,645Zm12.24-10.35a1.12,1.12,0,0,1-1-1.67,31.11,31.11,0,0,0,2.69-6.26,1.11,1.11,0,1,1,2.13.64,32.64,32.64,0,0,1-2.88,6.72A1.11,1.11,0,0,1,350.68,634.65Zm4.07-15.81a1.11,1.11,0,0,1-1.11-1.09,29.43,29.43,0,0,0-.94-6.74,1.11,1.11,0,0,1,2.16-.55,31.51,31.51,0,0,1,1,7.25,1.11,1.11,0,0,1-1.09,1.13Z"
      />
      <circle className={classes.cls14} cx="339.29" cy="581.52" r="23.37" />
      <path
        className={classes.cls8}
        d="M348.28,584.53v-5.28a9,9,0,0,0-9-9h0a9,9,0,0,0-9,9v5.28c0,2.87-.79,4-2.28,6.42h22.53C349.06,588.5,348.28,587.4,348.28,584.53Z"
      />
      <path
        className={classes.cls8}
        d="M339.29,595.54h0a3.4,3.4,0,0,1-3.4-3.4h6.79A3.4,3.4,0,0,1,339.29,595.54Z"
      />
      <path
        className={classes.cls8}
        d="M339.29,567.51a2.75,2.75,0,1,0,2.75,2.75A2.76,2.76,0,0,0,339.29,567.51Zm0,4.4a1.65,1.65,0,1,1,1.65-1.65A1.65,1.65,0,0,1,339.29,571.91Z"
      />
      <path
        className={classes.cls14}
        d="M339.29,610.1a28.59,28.59,0,1,1,20.2-8.37A28.38,28.38,0,0,1,339.29,610.1Zm0-54.93a26.36,26.36,0,1,0,18.63,7.72A26.15,26.15,0,0,0,339.29,555.17Z"
      />
      <path
        className={classes.cls11}
        d="M318.24,511.43a1.11,1.11,0,0,1-.78-1.9l7.3-7.31a1.12,1.12,0,0,1,1.58,1.58L319,511.11A1.14,1.14,0,0,1,318.24,511.43Z"
      />
      <path
        className={classes.cls11}
        d="M318.24,511.71a1.34,1.34,0,0,1-1-.41,1.39,1.39,0,0,1-.41-1,1.43,1.43,0,0,1,.41-1l7.31-7.3a1.39,1.39,0,0,1,2.37,1,1.42,1.42,0,0,1-.4,1l-7.31,7.3A1.35,1.35,0,0,1,318.24,511.71Zm7.31-9.53a.84.84,0,0,0-.59.24l-7.31,7.31a.83.83,0,0,0-.24.59.87.87,0,0,0,.24.59.86.86,0,0,0,1.19,0l7.3-7.31a.82.82,0,0,0,0-1.18A.82.82,0,0,0,325.55,502.18Z"
      />
      <path
        className={classes.cls11}
        d="M333.87,521.89h-.17l-12.16-1.83a1.12,1.12,0,1,1,.33-2.21L334,519.67a1.12,1.12,0,0,1-.16,2.22Z"
      />
      <path
        className={classes.cls11}
        d="M333.87,522.17l-.21,0-12.16-1.82a1.4,1.4,0,0,1-1.17-1.59,1.38,1.38,0,0,1,1.58-1.17l12.16,1.83a1.4,1.4,0,0,1,1.18,1.58A1.41,1.41,0,0,1,333.87,522.17Zm-12.16-4.06a.83.83,0,0,0-.13,1.66l12.16,1.83h.13a.84.84,0,0,0,.82-.71.83.83,0,0,0-.7-.95l-12.16-1.83Z"
      />
      <path
        className={classes.cls11}
        d="M309.61,508a1.12,1.12,0,0,1-1.1-1l-1.82-12.16a1.1,1.1,0,0,1,.93-1.27,1.12,1.12,0,0,1,1.27.94l1.83,12.16a1.12,1.12,0,0,1-.94,1.27Z"
      />
      <path
        className={classes.cls11}
        d="M309.61,508.25a1.4,1.4,0,0,1-1.37-1.19l-1.83-12.16a1.4,1.4,0,0,1,1.17-1.58,1.38,1.38,0,0,1,1,.25,1.41,1.41,0,0,1,.55.92L311,506.65a1.35,1.35,0,0,1-.25,1,1.39,1.39,0,0,1-.92.55Zm-1.82-14.39h-.13a.8.8,0,0,0-.54.33.82.82,0,0,0-.16.62L308.79,507a.84.84,0,0,0,.82.71h.13a.84.84,0,0,0,.55-.33.85.85,0,0,0,.15-.62l-1.83-12.16a.82.82,0,0,0-.33-.55A.78.78,0,0,0,307.79,493.86Z"
      />
      <g className={classes.cls6}>
        <path
          className={classes.cls4}
          d="M393.47,1068.81c-5.49,4.07-12.57,8.36-12.59,15.68a19.54,19.54,0,0,0,1.8,7.19c6.48,16.29,14.47,32,18.51,49.23a91.43,91.43,0,0,1,2.17,14.09H48.43c-8.85-8.59-16.55-20.37-13.43-32.56,4.13-16.07,24.6-21.91,28-38.19,3.3-16-12.14-29.93-12.57-46.35-.27-10.55,6-20.33,14.13-25.85s17.81-7.4,27.3-8.19a138,138,0,0,1,38.62,2.25c14.37,2.91,28.75,8.13,43.24,6.2a30.63,30.63,0,0,0,16-6.62c6.05-5.16,9.54-13.18,12-21.19,6.79-22,7.66-46.68,18.89-66.38,14.52-25.47,44.16-36.79,71.18-33.59s51.68,18.67,73.23,37c21.05,17.94,40.62,40.08,48.73,68.11S415.55,1052.47,393.47,1068.81Z"
        />
      </g>
      <path
        className={classes.cls4}
        d="M411,95.62a.5.5,0,0,0,0-1,.5.5,0,0,0,0,1Z"
      />
    </svg>
  </div>
);

export default BrandingContent;
